import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/global.css */
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    font-feature-settings: 'kern';
    shape-rendering: geometricPrecision;
    direction: ltr;
    line-height: 100%;
    font-weight: 400;
    color: #fff;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }
  a {
    color: #fff;
    text-decoration: none;
    text-decoration-color: rgba(255, 255, 255, 0.4);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }
  a:hover {
    text-decoration: none;
  }
  #ip_restricted_banner {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background: hsla(360, 88%, 46%, 0.3);
    -webkit-backdrop-filter: blur(15px);
    backdrop-filter: blur(15px);
    font-size: 0.8rem;
    padding: 3px 20px;
    letter-spacing: -0.01em;
    text-align: center;
    line-height: 120%;
    z-index: 99999999;
    width: 100%;
  }
  #ip_restricted_banner strong {
    font-weight: 800;
    display: block;
    text-align: center;
    text-transform: uppercase;
    font-size: 1.1rem;
    margin: 0 0 5px 0;
    display: none;
  }
  #ip_restricted_banner a {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  #ip_restricted_banner a:hover {
    color: #fff;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9) !important;
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background-color: hsla(0, 0%, 100%, 0.15);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
`

const developerCSS = css``

export const RestrictedBannerCSS = styled.div`
  /* position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 100; */
  ${designerCSS}
  ${developerCSS}
`
